export enum BaseballOutAttribute {
  SacrificeFly = 1055,
  SacrificeBunt = 1056,
}
